var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.toEditExtraFields
    ? _c(
        "w-modal",
        {
          attrs: { value: _vm.isOpen, "escape-close": "" },
          on: {
            input: function ($event) {
              _vm.toEditExtraFields = null
            },
          },
        },
        [
          _c("app-extra-fields-edit-modal", {
            attrs: { "name-settings": _vm.settings },
            on: {
              close: function ($event) {
                return _vm.close()
              },
              update: function ($event) {
                return _vm.onUpdate()
              },
            },
            model: {
              value: _vm.toEditExtraFields,
              callback: function ($$v) {
                _vm.toEditExtraFields = $$v
              },
              expression: "toEditExtraFields",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }